import { useContext, createContext } from "react";

export const NotificationsContext = createContext(null);

export function useNotificationsContext() {
  return useContext(NotificationsContext);
}
